import React from "react";
import PropTypes from "prop-types";
import { Box, FormHelperText } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useFormikContext } from "formik";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

function PhoneNumberTextField({ name, width }) {
  const theme = useTheme();
  const { setFieldValue, errors, setFieldTouched, touched, values } = useFormikContext();
  const showError = touched[name] && typeof errors[name] === "string";

  return (
    <Box>
      <PhoneInput
        specialLabel=""
        value={values[name]}
        country="my"
        onlyCountries={[
          "aw",
          "af",
          "ao",
          "ai",
          "ax",
          "al",
          "ad",
          "ae",
          "ar",
          "am",
          "ag",
          "aq",
          "as",
          "at",
          "au",
          "bs",
          "bh",
          "bb",
          "by",
          "be",
          "bz",
          "bj",
          "bm",
          "bt",
          "bo",
          "bq",
          "ba",
          "bw",
          "bv",
          "br",
          "io",
          "bn",
          "bg",
          "bf",
          "bi",
          "kh",
          "cm",
          "ca",
          "cv",
          "ky",
          "cf",
          "td",
          "cl",
          "cn",
          "cx",
          "cc",
          "co",
          "km",
          "cg",
          "cd",
          "ck",
          "cr",
          "hr",
          "cu",
          "cw",
          "cy",
          "cz",
          "dk",
          "dj",
          "dm",
          "do",
          "ec",
          "eg",
          "sv",
          "gq",
          "er",
          "ee",
          "sz",
          "et",
          "fk",
          "fo",
          "fj",
          "fi",
          "fr",
          "gf",
          "pf",
          "tf",
          "ga",
          "gm",
          "ge",
          "de",
          "gh",
          "gi",
          "gr",
          "gl",
          "gd",
          "gp",
          "gu",
          "gt",
          "gg",
          "gn",
          "gw",
          "gy",
          "ht",
          "hm",
          "va",
          "hn",
          "hk",
          "hu",
          "is",
          "in",
          "id",
          "iq",
          "ie",
          "im",
          "it",
          "ci",
          "jm",
          "jp",
          "je",
          "jo",
          "kz",
          "ke",
          "ki",
          "kr",
          "kw",
          "kg",
          "la",
          "lv",
          "lb",
          "ls",
          "lr",
          "ly",
          "li",
          "lt",
          "lu",
          "mo",
          "mg",
          "mw",
          "my",
          "mv",
          "ml",
          "mt",
          "mh",
          "mq",
          "mr",
          "mu",
          "yt",
          "mx",
          "fm",
          "md",
          "mc",
          "mn",
          "me",
          "ms",
          "ma",
          "mz",
          "mm",
          "na",
          "nr",
          "np",
          "nl",
          "nc",
          "nz",
          "ni",
          "ne",
          "nu",
          "nf",
          "mk",
          "no",
          "pw",
          "pa",
          "pg",
          "py",
          "pe",
          "ph",
          "pn",
          "pl",
          "pt",
          "pr",
          "qa",
          "re",
          "ro",
          "ru",
          "rw",
          "bl",
          "sh",
          "kn",
          "lc",
          "mf",
          "pm",
          "vc",
          "ws",
          "sm",
          "st",
          "sa",
          "sn",
          "rs",
          "sc",
          "sl",
          "sg",
          "sx",
          "sk",
          "si",
          "sb",
          "so",
          "za",
          "gs",
          "ss",
          "es",
          "sd",
          "sr",
          "sj",
          "se",
          "ch",
          "sy",
          "tw",
          "tz",
          "th",
          "tl",
          "tg",
          "tk",
          "to",
          "tt",
          "tr",
          "tm",
          "tc",
          "tv",
          "ug",
          "ua",
          "gb",
          "us",
          "um",
          "uy",
          "uz",
          "vu",
          "ve",
          "vn",
          "vg",
          "vi",
          "wf",
          "eh",
          "ye",
          "zm",
          "zw",
        ]}
        onBlur={() => setFieldTouched(name)}
        onChange={(e) => setFieldValue(name, `+${e}`)}
        inputStyle={{
          width,
          borderRadius: theme.shape.borderRadius[1],
          borderColor: showError && theme.palette.colors.ui.error,
          paddingTop: "10px",
          paddingBottom: "10px",
        }}
      />
      {showError && (
        <FormHelperText
          sx={{
            color: theme.palette.colors.text.error,
            margin: "3px 14px 0px 14px",
          }}
        >
          {errors[name]}
        </FormHelperText>
      )}
    </Box>
  );
}

PhoneNumberTextField.defaultProps = {
  width: "100%",
};

PhoneNumberTextField.propTypes = {
  name: PropTypes.string.isRequired,
  width: PropTypes.string,
};

export default PhoneNumberTextField;
